// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { onlyUpdateForPropTypes } from '../../../../node_module_clones/recompose';

// Components
import CurrentBoardHeaderTitle from '../../header/currentBoardHeader/CurrentBoardHeaderTitle';
import MobileBoardHeaderUtils from '../MobileBoardHeaderUtils';
import HeaderBackButtonHybrid from './HeaderBackButtonHybrid';

// Styles
import './MobileBoardHeaderHybrid.scss';

const MobileBoardHeaderHybrid = (props) => {
    const { isCurrentBoardRoot } = props;

    return (
        <div className="MobileBoardHeaderHybrid">
            <div className="header-left">{!isCurrentBoardRoot && <HeaderBackButtonHybrid {...props} />}</div>
            <div className="header-center">
                <CurrentBoardHeaderTitle {...props} />
            </div>
            <div className="header-right">
                <MobileBoardHeaderUtils {...props} />
            </div>
        </div>
    );
};

MobileBoardHeaderHybrid.propTypes = {
    currentBoardId: PropTypes.string.isRequired,
    currentBoard: PropTypes.object.isRequired,
    isCurrentBoardRoot: PropTypes.bool,
    isEditable: PropTypes.bool,
    getDocumentElementSizes: PropTypes.func,
};

export default onlyUpdateForPropTypes(MobileBoardHeaderHybrid);
